import { AxiosResponse } from 'axios';
import $api from '@/http/index';
import { IConversationDetail } from '@/models/chatai/IConversationDetail';
import { IConversationListResponse } from '@/models/chatai/IConversationListResponse';

export class ChatAIHistoryService {
    static async listConversations(
        params: { skip?: number; take?: number } = {},
    ): Promise<AxiosResponse<IConversationListResponse>> {
        const { skip = 0, take = 30 } = params;
        return $api.get(`/ChatAIHistory/conversations`, { params: { skip, take } });
    }

    static async getConversation(conversationId: string): Promise<AxiosResponse<IConversationDetail>> {
        return $api.get(`/ChatAIHistory/conversations/${conversationId}`);
    }

    static async renameConversation(conversationId: string, title: string): Promise<AxiosResponse<void>> {
        // suppressErrorNotification: 404 = тред уже удалён (race), обработчик в sidebar глотает
        // тихо. Generic-тост из interceptor'а («код 404») админам/dev не нужен.
        return $api.patch(
            `/ChatAIHistory/conversations/${conversationId}`,
            { title },
            { suppressErrorNotification: true },
        );
    }

    static async deleteConversation(conversationId: string): Promise<AxiosResponse<void>> {
        // suppressErrorNotification: 404 = race с другим табом/retention; sidebar обрабатывает
        // тихо. Прочие ошибки sidebar показывает своим notification'ом с осмысленным title.
        return $api.delete(`/ChatAIHistory/conversations/${conversationId}`, {
            suppressErrorNotification: true,
        });
    }
}
